import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  ButtonOBSOLETED,
  Notification,
  Message,
  Loader
} from '../../web.common';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import { v4 as uuidv4 } from 'uuid';

const containerStyle = {
  width: '50%',
  margin: 'auto',
  backgroundColor: 'white',
  border: "1px solid #e5e5e5",
  padding: "1.2rem"
};
const formSpanStyle = {
  display: "table-cell",
};
const rowStyle = {
  display: "table",
  width: "100%",
  margin: "auto auto 0px",
  position: "relative"
};
const formLabelStyle = {
  display: "table-cell",
  width: "30%",
  whiteSpace: "nowrap",
  fontWeight: "bold",
  verticalAlign: "top",
};

const TransactionReportInternal = ({ api }) => {

  const [downloading, setDownloading] = useState(null);
  const [editedNotification, setNotification] = useState(null);
  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);

  const validateForm = () => {
    const emptyFields = [];
    let response = {
      success: false,
      type: 'error',
      message: ''
    };

    if (from == null) {
      emptyFields.push('From');
    }
    if (to == null) {
      emptyFields.push('To');
    }

    if (to < from) {
      response.success = false;
      response.message = 'The To field must be a date after the From field';
      return response;
    }

    if (emptyFields.length == 1) {
      response.message = `Unable to send the request. The ${emptyFields} field is mandatory.`
    } else if (emptyFields.length > 1) {
      response.message = `Unable to send the request. ${emptyFields.join(', ')} are mandatory.`
    } else {
      response.success = true;
      response.type = 'success';
    }

    return response;
  }

  const generateReport = async (event) => {
    const validationResponse = validateForm();
    if (validationResponse.success == false) {
      event.preventDefault();
      setNotification(new Message(validationResponse.type, validationResponse.message));
      return;
    }
    try {
      setDownloading(`Retrieving data from ${from} to ${to} ...`);
      var data = await api.transactions.generateTransactionReport({
        from: from,
        to: to
      });

      downloadData(data);

      setNotification(new Message('success', 'Download is ready'));
    } catch (e) {
      setNotification(new Message('error', 'Error while retrieving data'));
      console.error(e);
    } finally {
      setDownloading(null);
    }
  }

  const downloadData = (data) => {
    const reportGuid = uuidv4();
    var binaryData = [];
    binaryData.push(data);
    const blob = new Blob(binaryData, { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = `${reportGuid}.csv`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  }

  return (
    <LayoutContext.Consumer>
      {() => (
        <React.Fragment>
          <Notification newMessage={editedNotification} />
          <PageTop
            documentTitle='Settlement Report'
            documentDescription='Settlement Report'
          />

          <h2 className='main-page-header'>
            Settlement Report
          </h2>

            <div style={containerStyle}>
              <div style={rowStyle}>
                <label style={formLabelStyle} htmlFor="report-from">From</label>
                <span style={formSpanStyle}>
                  <input type="date" id="report-from" onChange={({ target }) => {
                    setFrom(target.value);
                  }} />
                </span>
              </div>
              <br />
              <div style={rowStyle}>
                <label style={formLabelStyle} htmlFor="report-to">To (excluded)</label>
                <span style={formSpanStyle}>
                  <input type="date" id="report-to" onChange={({ target }) => {
                    setTo(target.value);
                  }} />
                </span>
              </div>
              <br />
              <p>* The end date is excluded from the report</p>
            </div>
            <br />
            <div style={{ 'display': 'flex', 'justifyContent': 'center', 'marginTop': '2%' }}>
            <div >
              {downloading ?
              <ButtonOBSOLETED
                  type="submit"
                  buttonContent="Get Report"
                  disabled={true}
                  /> :
              <ButtonOBSOLETED
                type="submit"
                buttonContent="Get Report"
                onClick={async (e) => {
                  e.preventDefault();
                  await generateReport(e);
                }} />
                }
            </div>
          </div>
          {
            <p><br /><br /><b>{downloading ? downloading : ''}</b></p>
          }
          {downloading && <Loader />}
        </React.Fragment>
      )}
    </LayoutContext.Consumer>
  );
}

const TransactionReport = withRouter(withApi(
  connect(({ user }) => ({ isLoggedIn: !!user }), {})(TransactionReportInternal)
));

TransactionReport.requiresLogin = true;
TransactionReport.propTypes = { isLoggedIn: PropTypes.bool };

export default TransactionReport;
